module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEZSURBVHgBlVSBFYIgEIUmcIPYIDbINnAD3CA30A0awRGqCWwDbQJHsA3oeH3q5IHavfcfcHy+d8eJFBGz1mY0GIJm7hfhLqV8iDUjAUVo7c96Qgd4Gx1vSUSDNBFqRBVySoiqpUim1a/Nz1wJJnSOf4o0SHP6Rk6TAk6zUcTzLxhrHuK4UUT56LHuXFRuviMowhAcyEDSgVZLcKmcsL65NfH2YhbeXMjXLQvqYhgvh+8o/HVH0shZLbSfJzhHYSP9wogVu50x5NL6jP2kBid3EFKJvZ473K/QLIjFujwPayZYT2ztpVkbhJs9xKqtIrF0/ZW3EHO5G99HOFygeS1EtFj5YglizJIvg1xKgYaD+HSysyc9akOK/wapO9wKAnTfqgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zaixian_bai.png
// module id = cxmJ
// module chunks = 5